var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex primary--text align-center"},[_c('img',{staticClass:"mr-2",attrs:{"src":require("@/assets/logo_demo.svg"),"height":"32px","alt":_vm.title}}),_c('div',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }